import type { LeadFilter } from '@shared/schemas.js';
import { OPPORTUNITY_LABELS, OPPORTUNITY_TYPES, IMPROVEMENT_CATEGORIES, IMPROVEMENT_LABELS } from '@shared/opportunities.js';
import { Field, Select } from './ui/primitives';
export function OpportunityFilter({ filter, onChange, queue = false }: {
    filter: LeadFilter;
    onChange: (value: Partial<LeadFilter>) => void;
    queue?: boolean;
}) {
    return <>
    <Field label="Opportunity type">
      <Select value={filter.opportunityTypes?.[0] ?? ''} onChange={e => onChange({ opportunityTypes: e.target.value ? [e.target.value as NonNullable<LeadFilter['opportunityTypes']>[number]] : undefined })}>
        <option value="">{queue ? 'Default caller pool' : 'All opportunity types'}</option>
        {OPPORTUNITY_TYPES.map(type => <option key={type} value={type}>{OPPORTUNITY_LABELS[type]}</option>)}
      </Select>
    </Field>
    <Field label="Improvement category">
      <Select value={filter.improvementCategories?.[0] ?? ''} onChange={e => onChange({ improvementCategories: e.target.value ? [e.target.value as NonNullable<LeadFilter['improvementCategories']>[number]] : undefined })}>
        <option value="">All categories</option>
        {IMPROVEMENT_CATEGORIES.map(category => <option key={category} value={category}>{IMPROVEMENT_LABELS[category]}</option>)}
      </Select>
    </Field>
  </>;
}
